<template>
    <div class="lc-toast-container">
        <Toast
            v-for="toast in toasts"
            :key="toast.id"
            :type="toast.type"
            :message="toast.message"
            @close="removeToast(toast.id)"
        />
    </div>
</template>

<script>
    import Toast from './Toast'
    import useToast from './useToast'

    export default {
        name: 'LcToastContainer',
        components: { Toast },
        setup() {
            const { toasts, removeToast } = useToast()
            return { toasts, removeToast }
        },
    }
</script>

<style lang="scss" scoped>
.lc-toast-container {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    z-index: z(notification);
    max-width: 360px;
    width: 100%;
    pointer-events: none;

    > * { pointer-events: auto; }
}
</style>
